import { Grid } from '@mui/material'
import { ImgProfile } from './styledComponent'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import { getData } from 'country-list'
import { getDataWithoutParams } from 'src/consumer/services/featureServices'
import { Spinner } from 'react-bootstrap'

export default function MedicalBoardGrid() {
  const [boardDataLoading, setBoardDataLoading] = useState(true)
  const [boardData, setBoardData] = useState(null)
  const navigate = useNavigate()
  const getBoardMember = async () => {
    const res = await getDataWithoutParams(`/api/medical-board`)
    setBoardDataLoading(false)
    if (res.status !== 200) {
      navigate('/404')
    } else {
      return res
    }
  }

  useEffect(() => {
    getBoardMember().then((res) => {
      setBoardData(res?.data)
    })
  }, [])

  return (
    <div style={{ maxWidth: '85%' }} className="p-4 mx-auto d-flex justify-content-center">
      <Grid container spacing={2} justifyContent={'center'}>
        {boardDataLoading ? (
          <Spinner />
        ) : (
          boardData?.map((item, idx) => (
            <Grid key={`${item?.id}_${idx}`} item xs={12} sm={8} md={6} lg={4} xl={3}>
              <ProfileCard
                mentorTo={item?.id}
                name={item?.name}
                designation={item?.designation}
                key={`profile_${item?.id}_${idx}`}
                img={item?.coverIcon}
              />
            </Grid>
          ))
        )}
      </Grid>
    </div>
  )
}

function ProfileCard({ name, designation, img, mentorTo }) {
  return (
    <div style={{ textAlign: 'center' }}>
      <Link to={mentorTo || '#'} style={{ textDecoration: 'none' }}>
        <div>
          <ImgProfile className="img-fluid" src={getImageLink(img) || '/boardDoctorImg.jpg'} />
        </div>
        <div className="text-center m-4 text-dark">
          <h3>{name || 'Name'}</h3>
          <p>{designation || 'Designation'}</p>
        </div>
      </Link>
    </div>
  )
}
